import styled from '@emotion/styled'
import { breakpointMax, calcRem, metrics } from '../../__styling'
import { tokens } from '@news-mono/design-tokens'

const { m2l, lg } = metrics.thenightly.margins
const { greyCoal } = tokens.perthnow.colors.palette
export const StyledDeleteAccount = styled.form(({ theme }) => [
    {
        display: 'flex',
        flexDirection: 'column',

        [breakpointMax('sm')]: {
            alignItems: 'stretch',
        },
    },
    //PerthNow styles
    theme.kind === 'perthnow' && {
        marginTop: calcRem(16),

        p: {
            color: theme.colors.text.weak,
            fontFamily: theme.fonts.sansSerif,
            // Styling the Privacy Policy link specifically
            a: {
                color: greyCoal,
            },
        },
    },
])

export const StyledActionGroup = styled.div(({}) => ({
    display: 'flex',
    justifyContent: 'end',
    paddingTop: calcRem(lg),
    alignItems: 'center',
    gap: calcRem(m2l),

    [breakpointMax('sm')]: {
        flexDirection: 'column-reverse',
    },
}))

export const StyleButtonWrapper = styled.div(({}) => ({
    display: 'flex',
    flexDirection: 'column',

    [breakpointMax('sm')]: {
        width: '100%',
    },
}))

export const StyledCheckboxGroup = styled.div(({}) => ({
    paddingTop: calcRem(m2l),
}))
